import React from 'react';

import Col from 'react-bootstrap/Col';
import CustomTd from '../shared/table/CustomTd';
import EditDeleteButton from '../shared/buttons/EditDeleteButton';
import Form from 'react-bootstrap/Form';
import formatter from '../../utilities/formatter';

const PaymentItem = ({
    item,
    editItem,
    deleteItem
}) => {

    return (
        <tr>
            <CustomTd>
                <Form.Row>
                    <Col md='7'>
                        <Form.Row>
                            <Col sm="6" className="mb-1 mb-md-0" style={{ height: '1.9em', paddingTop: '2px' }}>
                                    {formatter.date(item.date)}
                                </Col>
                            <Col className="mb-1 mb-md-0" style={{ height: '1.9em', paddingTop: '2px' }}>
                                    {item.paymentTypeName}
                                </Col>
                        </Form.Row>
                    </Col>
                    <Col md="5">
                        <Form.Row>
                            <Col style={{ height: '1.9em', paddingTop: '2px' }}>
                                {formatter.currency(item.amount)}
                            </Col>
                            <Col xs="6" md="auto" style={{ height: '1.9em', paddingTop: '2px' }}>
                                {item.isDeposit && '✓ Deposit'}
                            </Col>
                        </Form.Row>
                    </Col>
                </Form.Row>
            </CustomTd>
            <CustomTd className="button-cell" width={90}>
                <div style={{ height: '1.9em', paddingTop: '2px' }}>
                <EditDeleteButton
                    canEdit={true}
                    editItem={editItem}
                    canDelete={true}
                    deleteItem={deleteItem}
                    acl={item.acl}
                        showText={false} />
                    </div>
            </CustomTd>
        </tr >
    );
}

export default PaymentItem;